import React from 'react';
import { useQuery } from '@apollo/client';
import {
  IRecentActivityQuery,
  IRecentActivityQueryVariables,
} from '../../../../utils/apollo/graphqlSchema';
import { GET_RECENT_ACTIVITY } from '../../../../utils/apollo/recentActivity';
import { ContentLoader } from '../../../../components/Loaders';
import RecentActivityTable from './RecentActivityTable';

const MAX_ACTIVITIES = 8;

const RecentActivityTableContainer = () => {
  const { data, loading } = useQuery<
    IRecentActivityQuery,
    IRecentActivityQueryVariables
  >(GET_RECENT_ACTIVITY);

  const recentActivity = data?.recentActivity;

  if (loading || !recentActivity) {
    return <ContentLoader />;
  }

  const slicedRecentActivity = recentActivity.slice(0, MAX_ACTIVITIES);

  return <RecentActivityTable recentActivity={slicedRecentActivity} />;
};

export default RecentActivityTableContainer;
